export const APP_CORE_UPDATED = 'APPCORE_UPDATED';
export const APP_CORE_OTP_UPDATED = 'APPCORE_OTP_UPDATED';